const ctx = require('./index');

export function getAndroidVersion(s) {
    return ctx.getAndroidVersion(s);
}
export function getAndroidMajorVersion(s) {
    return ctx.getAndroidMajorVersion(s);
}
export function getIOSVersion(s) {
    return ctx.getIOSVersion(s);
}
export function getWechat(s) {
    return ctx.getWechat(s);
}